import { PageContent } from '../../components/core'

export const WalletManagementPage = () => {
    return (
        <PageContent>
            <></>
        </PageContent>
    )
}